<template>
    <div class="goods-offline">
        <!-- 顶部店铺信息 -->
        <div class="shop-author-info" v-if="profile.shop">
            <div class="author-left">
                <img :src="profile.shop.logo | default_img(false)" alt="" class="author-avatar" />
                <div class="author-info">
                    <div class="shop-name">{{ profile.shop.shop_name || '' }}</div>
                    <div class="author-info-line">
                        <div class="count">作品数:{{ profile.design_count || 0 }}</div>
                        |
                        <div class="count">{{ profile.shop && profile.shop.fans_count || 0 }}人关注</div>
                    </div>
                </div>
            </div>
            <div class="author-right">
                <div :class="['btn-item', { 'shop-collected': is_shop_collect }]" @click="onShopCollect">
                    <img v-if="!is_shop_collect" src="@/assets/images/icon-like.png" alt="" class="btn-icon">
                    {{ is_shop_collect ? '已关注' : '关注' }}
                </div>
                <div class="btn-item" @click="onEnterShop">
                    <img src="@/assets/images/icon-store.png" alt="" class="btn-icon">
                    进店
                </div>
            </div>
        </div>

        <!-- 下架提示 -->
        <div class="offline-tip">
            <img src="@/assets/images/product-un-sale.png" alt="" class="offline-img" />
            <div class="offline-text">很抱歉，宝贝不存在了 看看其他的吧~</div>
        </div>

        <!-- 同店好物推荐 -->
        <div class="same-shop-recommend" v-if="shop_product_list.length">
            <div class="section-title">同店好物推荐</div>
            <div class="recommend-list">
                <div class="recommend-item" v-for="(item, index) in shop_product_list" :key="`shop-${index}`" @click="onGoDetail(item)">
                    <div class="recommend-img-box">
                        <img :src="item.image | default_img(false)" alt="" class="recommend-img" />
                    </div>
                    <div class="recommend-title">{{ item.name }}</div>
                    <div class="recommend-price">¥{{ item.sale_price }}</div>
                </div>
            </div>
        </div>

        <!-- 猜你喜欢 -->
        <div class="detail-bottom">
            <div class="bottom-title">猜你喜欢</div>
            <div class="bottom-list">
                <div class="goods-item" v-for="(item, index) in product_list" :key="`like-${index}`" @click="onGoDetail(item)">
                    <div class="goods-cover">
                        <img :src="item.image | default_img(false)" alt="" />
                        <div class="collect-btn" @click.stop="onCollectProduct(item, index)">
                            <img :src="item.is_collected ? require('@/assets/images/icon-mall-collected.png') : require('@/assets/images/icon-mall-collect.png')" alt="" class="collect-icon">
                            {{ item.is_collected ? '已收藏' : '收藏' }}
                        </div>
                    </div>
                    <div class="goods-title">{{ item.name }}</div>
                    <div class="goods-price">¥{{ item.sale_price }}</div>
                    <div class="goods-author">
                        <img :src="item.member.avatar | default_img(false)" alt="" class="avatar" />
                        <div class="nickname">{{ item.member.nickname || '匿名' }}</div>
                        <div class="line">|</div>
                        <div class="count-num">作品:{{ item.member.works }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 侧边栏 -->
        <mall-side></mall-side>
    </div>
</template>
<script>
import {
    getMallProductList,
    MallShopCollect,
    productCollect,
    ProductList,
    ProfileNoAuth
} from '@/api/index';
import MallSide from './components/MallSide.vue';
export default {
    data() {
        return {
            uid: '',
            profile: {
                shop: {}
            },
            is_shop_collect: false,
            shop_product_list: [],
            product_list: []
        };
    },
    components: { MallSide },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.$emit('changeFooter', 'mall');
        });
    },
    async mounted() {
        this.uid = this.$route.query.uid || '';
        await Promise.all([
            this.onGetProfile(),
            this.onGetShopProductList(),
            this.onGetMallProductList()
        ]);
    },
    methods: {
        async onGetProfile() {
            if (!this.uid) return;
            try {
                const { code, data, msg } = await ProfileNoAuth({ code: this.uid });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.profile = data;
                this.is_shop_collect = !!data.is_shop_collect;
            } catch (e) {
                console.log('err-offline-profile', e);
            }
        },
        async onGetShopProductList() {
            if (!this.uid) return;
            try {
                const res = await ProductList({ code: this.uid, status: 'onsale', page: 1, size: 6 });
                this.shop_product_list = (res.data || []).slice(0, 6);
            } catch (e) {
                console.log('err-shop-product-list', e);
            }
        },
        async onGetMallProductList() {
            try {
                const { code, data, msg } = await getMallProductList({ page: 1, size: 15 });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.product_list = data.list || [];
            } catch (e) {
                console.log('err-mall-product-list', e);
            }
        },
        async onShopCollect() {
            if (!this.profile.shop || !this.profile.shop.id) {
                this.$layer.msg('店铺信息缺失~');
                return;
            }
            try {
                const { code, msg } = await MallShopCollect({ shop_id: this.profile.shop.id });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.is_shop_collect = !this.is_shop_collect;
                this.$layer.msg('操作成功~');
            } catch (e) {
                console.log('err-shop-collect', e);
            }
        },
        onEnterShop() {
            this.$router.push({ name: 'ShopHome', query: { uid: this.uid } });
        },
        onGoDetail(item) {
            if (!item.uuid) return;
            this.$router.push({ name: 'GoodsDetail', params: { uuid: item.uuid } });
        },
        async onCollectProduct(item, index) {
            try {
                const { code, msg } = await productCollect({ uuid: item.uuid });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                this.$set(this.product_list[index], 'is_collected', !item.is_collected);
                this.$layer.msg('操作成功~');
            } catch (e) {
                console.log('err-collect', e);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.goods-offline {
    width: 100%;
    background: #ffffff;
    padding: 24px 180px 50px;
    box-sizing: border-box;
    user-select: none;

    .shop-author-info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .author-left {
            display: flex;
            align-items: center;
            column-gap: 12px;

            .author-avatar {
                width: 60px;
                height: 60px;
                border-radius: 8px;
                border: 1px solid #e3e3e3;
                background: #ebebeb;
                object-fit: cover;
            }

            .author-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                row-gap: 6px;

                .shop-name {
                    color: #333333;
                    font-size: 20px;
                    font-weight: bold;
                }

                .author-info-line {
                    display: flex;
                    align-items: center;
                    column-gap: 16px;

                    .count {
                        color: #666666;
                        font-size: 12px;
                    }
                }
            }
        }

        .author-right {
            display: flex;
            align-items: center;
            column-gap: 12px;

            .btn-item {
                width: 78px;
                height: 40px;
                line-height: 40px;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 3px;
                cursor: pointer;

                .btn-icon {
                    width: 20px;
                    height: 20px;
                }

                &.shop-collected {
                    background: #ff5967;
                    color: #ffffff;
                }
            }
        }
    }

    .offline-tip {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 60px;

        .offline-img {
            width: 268px;
            height: 232px;
            object-fit: contain;
        }

        .offline-text {
            color: #666666;
            font-size: 16px;
            font-weight: 500;
            margin-top: 20px;
            text-align: center;
        }
    }

    .same-shop-recommend {
        width: 100%;
        margin-top: 80px;

        .section-title {
            color: #1a1a1a;
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 30px;
        }

        .recommend-list {
            width: 100%;
            display: flex;
            column-gap: 17px;

            .recommend-item {
                width: calc((100% - 85px) / 6);
                display: flex;
                flex-direction: column;
                cursor: pointer;

                .recommend-img-box {
                    width: 100%;
                    height: 325px;
                    border: 1px solid #e3e3e3;
                    border-radius: 10px;
                    overflow: hidden;
                    background: #f5f5f5;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .recommend-img {
                        width: 100%;
                        height: auto;
                        display: block;
                        object-fit: contain;
                    }
                }

                .recommend-title {
                    color: #1a1a1a;
                    font-size: 16px;
                    margin-top: 12px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .recommend-price {
                    color: #1a1a1a;
                    font-size: 18px;
                    font-weight: bold;
                    margin-top: 6px;
                }
            }
        }
    }

    .detail-bottom {
        max-width: 100%;
        background: #ffffff;
        border-radius: 6px;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0;

        .bottom-title {
            width: 100%;
            text-align: left;
            margin-top: 20px;
            color: #1a1a1a;
            font-size: 22px;
            font-weight: bold;
        }

        .bottom-list {
            width: 100%;
            display: flex;
            margin-top: 40px;
            flex-wrap: wrap;
            gap: 25px;
            padding-bottom: 30px;

            .goods-item {
                width: calc(100% / 5 - 25px);
                background: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: start;
                cursor: pointer;

                .goods-cover {
                    width: 100%;
                    height: 430px;
                    min-height: 0;
                    border-radius: 6px;
                    background: #f5f5f5;
                    overflow: hidden;
                    position: relative;
                    display: flex;

                    img {
                        width: 100%;
                        height: auto;
                        display: block;
                        border-radius: 6px;
                        object-fit: contain;
                    }

                    .collect-btn {
                        display: none;
                    }

                    &:hover {
                        .collect-btn {
                            position: absolute;
                            right: 20px;
                            bottom: 20px;
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: 16px;
                            color: #4d4d4d;
                            font-size: 12px;
                            display: flex;
                            align-items: center;
                            column-gap: 4px;
                            padding: 6px 10px;
                            cursor: pointer;
                            max-height: 32px;

                            .collect-icon {
                                width: 20px;
                                height: 20px;
                                max-height: 20px;
                                min-height: 20px;
                            }
                        }
                    }
                }

                .goods-title {
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 16px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 100%;
                }

                .goods-price {
                    line-height: 35.81px;
                    color: #1a1a1a;
                    font-size: 18px;
                    font-weight: bold;
                }

                .goods-author {
                    display: flex;
                    align-items: center;
                    width: 100%;

                    .avatar {
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                        margin-right: 9px;
                    }

                    .line {
                        margin: 0 9px;
                        font-size: 13px;
                    }

                    .nickname,
                    .count-num {
                        flex: 0 0 1;
                        color: #666666;
                        font-size: 13px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
</style>
